<button type="submit" mat-flat-button class="primary" [disabled]="disabled || isLoading" [disableRipple]="true">
  <span class="spinner-border spinner-border-sm mr-4" role="status" *ngIf="isLoading"></span>
  <ng-content></ng-content>
</button>